import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ComponentHolderComponent } from '../components/component-holder/component-holder';
import { VerticalTabComponent } from '../components/vertical-tab/vertical-tab';
import { MainComponent } from '../components/main-component/main-component';
import { componentHolderService } from '../providers/component-holder.service/component-holder.service';
import { HttpClientModule} from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ComponentServiceProvider } from '../providers/component-service/component-service';
import { ModalPopupPage } from '../pages/modal-popup/modal-popup';
import { SideMenuComponent } from '../components/side-menu/side-menu';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { DatePipe } from '@angular/common';
import { ProjectComponent } from '../components/project/project';
import { MspPricingSheetComponent } from '../components/msp-pricing-sheet/msp-pricing-sheet';
import { AddDeviceComponent } from '../components/add-device/add-device';
import { BackupdrPricingSheetComponent } from '../components/backupdr-pricing-sheet/backupdr-pricing-sheet';
import { CyberPricingSheetComponent } from '../components/cyber-pricing-sheet/cyber-pricing-sheet';
import { HardwareSoftwareSheetComponent } from '../components/hardware-software-sheet/hardware-software-sheet';
import { TooltipsModule } from 'ionic-tooltips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CloudPricingSheetComponent } from '../components/cloud-pricing-sheet/cloud-pricing-sheet';
import { PriceListComponent } from '../components/price-list/price-list';
import { PriceListTableProvider } from '../providers/price-list-table/price-list-table';
import { ExportServiceProvider } from '../providers/export-service/export-service';
import { DataServiceProvider } from '../providers/data-service/data-service';
import { CoverScreenComponent } from '../components/cover-screen/cover-screen';
import { ConfigApiServiceProvider } from '../providers/config-api-service/config-api-service';
import { MsaPage } from '../pages/msa/msa';
import { ProposalComponent } from '../components/proposal/proposal';
import { AddClientDetailsComponent } from '../components/add-client-details/add-client-details';
import { ReactiveFormsModule } from '@angular/forms';
import { AzureUploadComponent } from '../components/azure-upload/azure-upload';
import { CommunicationServiceProvider } from '../providers/communication-service/communication-service';
import { PricelistMasterPage } from '../pages/pricelist-master/pricelist-master';
import { SowPage } from '../pages/sow/sow';
import { SowListPage } from '../pages/sow-list/sow-list';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ComponentHolderComponent,
    MainComponent,
    VerticalTabComponent,
    ModalPopupPage,
    SideMenuComponent,
    ProjectComponent,
    CoverScreenComponent,
    MspPricingSheetComponent,
    AddDeviceComponent,
    BackupdrPricingSheetComponent,
    CyberPricingSheetComponent,
    HardwareSoftwareSheetComponent,
    CloudPricingSheetComponent,
    PriceListComponent,
    MsaPage,
    SowPage,
    SowListPage,
    PricelistMasterPage,
    ProposalComponent,
    AddClientDetailsComponent,
    AzureUploadComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpClientModule, 
    AngularEditorModule,
    AngularDateTimePickerModule,
    TooltipsModule.forRoot(),
    BrowserAnimationsModule,
    ReactiveFormsModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ComponentHolderComponent,
    ModalPopupPage,
    VerticalTabComponent,
    ProjectComponent,
    CoverScreenComponent,
    MspPricingSheetComponent,
    AddDeviceComponent,
    BackupdrPricingSheetComponent,
    CyberPricingSheetComponent,
    HardwareSoftwareSheetComponent,
    CloudPricingSheetComponent,
    PriceListComponent,
    MsaPage,
    SowPage,
    SowListPage,
    PricelistMasterPage,
    ProposalComponent,
    AddClientDetailsComponent,
    AzureUploadComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    componentHolderService,
    ComponentServiceProvider,
    DatePipe,
    PriceListTableProvider,
    ExportServiceProvider,
    DataServiceProvider,
    ConfigApiServiceProvider,
    CommunicationServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts